<template>
  <div class="workspace leftMargin">

    <el-dialog v-model="settingsDialogVisible" width="30%">
      <template #title>
        <div class="mainHeading txt" style="text-align: left;">Settings</div>
      </template>
      <div style="margin: 30px 0px 0px 40px; display: flex; align-items: center;">
        <span class="subheading txt" style="margin-right: 20px;">Selection Highlight Color:</span>
        <el-color-picker v-model="selectionHighlightColor" size="large"></el-color-picker>
      </div>
      <div style="margin: 30px 0px 0px 40px; display: flex; align-items: center;">
        <span class="subheading txt" style="margin-right: 20px;">Workspace Background Color:</span>
        <el-color-picker v-model="workspaceBackgroundColor" size="large" show-alpha></el-color-picker>
      </div>
      <div style="margin: 30px 0px 40px 40px; display: flex; align-items: center;">
        <span class="subheading txt" style="margin-right: 20px;">Use Checkered Pattern:</span>
        <el-switch v-model="workspaceBackgroundPattern"></el-switch>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="settingsDialogVisible = false">Close</el-button>
        </span>
      </template>
    </el-dialog>
    
    <div class="workspaceContainer" @wheel.prevent="onWheel">
      
      <div v-if="svgAvailable" class="optionsBar floatingOptions">
        <div class="optionsGroup">
          <el-button class="bottomOptionsCircleItem" :icon="Plus" @click="zoom(10)" circle size="mini"></el-button>
          <div class="bottomOptionsTextItem" id="zoomval">Zoom</div>
          <el-button class="bottomOptionsCircleItem" :icon="Minus" @click="zoom(-10)" circle size="mini"></el-button>
        </div>
        
        <div class="optionsGroup">
          <el-button class="btntxt" type="text" size="medium" @click="newUpload">Upload New</el-button>
          <el-button class="btn" type="primary" size="medium" @click="save" >Download</el-button>
          <el-button :icon="Setting" circle size="medium" @click="settingsDialogVisible = true"></el-button>
        </div>
      </div>

      <div id="svgHolder" :style="[svgAvailable? {padding: '48px'} : {}, workspaceStyle, { flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }]" @mouseover="onElementHover" @mouseout="onElementOut" @click="onElementClick"></div>

      <!--<div v-if="!svgAvailable" id="uploadHolder" style="padding: 20px">-->
        
      <!--<div :style="[svgAvailable? { visibility: 'collapse', display: 'none' } : { visibility: 'visible', padding: '20px'}]" id="uploadHolder">-->
        <div style="visibility: collapse; display: none" id="uploadHolder">
          <el-upload
            class="upload-demo"
            drag
            accept="image/svg"
            action=""
            :before-upload="onUpload">
            <el-icon id="uploadComponent" class="el-icon--upload"><upload /></el-icon>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <template #tip>
              <div class="el-upload__tip">
                svg files with a size less than 500kb
              </div>
            </template>
          </el-upload>
        <div style="width: 100%;height: 100px;" >
          <Samples v-on:on-sample-selected="onSampleClick($event)" />
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { SVG, extend as SVGextend, Element as SVGElement } from '@svgdotjs/svg.js' // eslint-disable-line no-unused-vars
import { getColorsFromSvg, setColorsOnSvg, setSizeTo, getSize, getColor, isColor, getFillValue, isValidColorHolderElement } from '../js/recolor.js'
import { selectAtMouseXY, registerSelectionClick } from '../js/selection.js' // eslint-disable-line no-unused-vars
import { Plus, Minus, Setting, Upload } from '@element-plus/icons-vue'
//import Samples from './Samples.vue'

export default {
  name: 'Workspace',
  components: {
    //Samples
  },
  setup() {
    return {
      Plus,
      Minus,
      Setting,
      Upload
    }
  },
  props: { 
    newColors: Array, 
    newSVG: String,
    highlightColor: String,
    resetSvg: Boolean,
    newElementColor: String,
    newElementTranslate: Object,
    newElementScale: Number,
    newElementRotate: Number,
    clearSelection: Boolean
  },
  data() {
      return {
        zoomval: 100,
        svgSize: [0,0],
        svgContent: '',
        svgColors: [],
        svgAvailable: false,
        svgLoadError: '',
        originalSvgContent: '',
        hoveredNode: null,
        selectedNodes: [],
        settingsDialogVisible: false,
        selectionHighlightColor: '#ff0000',
        workspaceBackgroundColor: '#ffffff',
        workspaceBackgroundPattern: true
      }
    },
  computed: {
    workspaceStyle() {
      if (this.workspaceBackgroundPattern) {
        return {
          backgroundColor: '#e5e5f7',
          backgroundImage: 'repeating-linear-gradient(45deg, #c4c4cc 25%, transparent 25%, transparent 75%, #c4c4cc 75%, #c4c4cc), repeating-linear-gradient(45deg, #c4c4cc 25%, #e5e5f7 25%, #e5e5f7 75%, #c4c4cc 75%, #c4c4cc)',
          backgroundPosition: '0 0, 10px 10px',
          backgroundSize: '20px 20px',
          minHeight: '100%',
          borderRadius: '8px'
        }
      }
      return {
        backgroundColor: this.workspaceBackgroundColor,
        minHeight: '100%',
        borderRadius: '8px'
      }
    }
  },
  watch: {
    resetSvg(newVal, oldVal){ // eslint-disable-line no-unused-vars
      if(newVal!=oldVal){
        console.log("resetting svg to original colors")
        this.resetSvgContent();
      }
    },
    highlightColor(newVal, oldVal){// eslint-disable-line no-unused-vars
      if(newVal){
        console.log("highlighting for col:"+newVal)
        this.applyColorHighlight(newVal);
      }else if(oldVal){
        console.log("removing highlight for col:"+oldVal)
        this.removeColorHighlight(oldVal);
      }
    },
    newSVG(newVal, oldVal){// eslint-disable-line no-unused-vars
      this.onSampleClick(newVal);
    },
    newColors(newVal, oldVal) { // eslint-disable-line no-unused-vars
      //console.log("watch new: "+newVal+" old:"+oldVal+" svgCol:"+this.svgColors);
      if(newVal!=null && newVal.size!=0){
        if(!this.arrayEquals(newVal, this.svgColors)){
          this.recolor(newVal, this.svgColors);
        }else{
          console.log("new and svg are equal!");
        }
      }else{
        console.log("new Val is empty!");
      }
    },
    newElementColor(newVal) {
      if (newVal && this.selectedNodes.length > 0) {
        this.selectedNodes.forEach(node => {
          node.setAttribute('fill', newVal);
        });
      }
    },
    newElementTranslate() {
      this.applyTransforms();
    },
    newElementScale() {
      this.applyTransforms();
    },
    newElementRotate() {
      this.applyTransforms();
    },
    clearSelection() {
      this.unselectElement();
    },
    zoomval(){
      this.setSvg(this.svgContent);
    },
    svgLoadError(){
      if(this.svgLoadError!=''){
        this.$message.error(this.svgLoadError);
      }
    }
  },
  methods:{
    applyTransforms() {
      if (this.selectedNodes.length > 0) {
        let tX = this.newElementTranslate ? this.newElementTranslate.x : 0;
        let tY = this.newElementTranslate ? this.newElementTranslate.y : 0;
        let s = this.newElementScale !== undefined && this.newElementScale !== null ? this.newElementScale : 1;
        let r = this.newElementRotate !== undefined && this.newElementRotate !== null ? this.newElementRotate : 0;

        this.selectedNodes.forEach(node => {
          if (!node.hasAttribute('data-original-transform')) {
             node.setAttribute('data-original-transform', node.getAttribute('transform') || '');
          }
          let originalTransform = node.getAttribute('data-original-transform');
          
          let bbox = node.getBBox();
          let cx = bbox.x + bbox.width / 2;
          let cy = bbox.y + bbox.height / 2;
          
          let transformStr = originalTransform;
          
          // Apply translation
          if (tX !== 0 || tY !== 0) {
            transformStr += ` translate(${tX}, ${tY})`;
          }
          
          // Apply scaling (scaling from center of bounding box)
          if (s !== 1) {
             transformStr += ` translate(${cx}, ${cy}) scale(${s}) translate(${-cx}, ${-cy})`;
          }

          // Apply rotation (rotating from center of bounding box)
          if (r !== 0) {
             transformStr += ` rotate(${r}, ${cx}, ${cy})`;
          }

          node.setAttribute('transform', transformStr.trim());
        });
      }
    },

    //############# COLOR ################
    sampleColors(){
      var colors = getColorsFromSvg(this.svgContent);
      this.updateCurrentPallette(colors);
    },
    recolor(newColors, oldColors){
      //console.log("recoloring "+oldColors+" with "+newColors);
      var newSvgContent = setColorsOnSvg(this.svgContent, newColors, oldColors)
      this.setSvg(newSvgContent);
      this.updateCurrentPallette(newColors);
    },
    updateCurrentPallette(colors){
      this.svgColors = colors;
      //console.log("new event: sending colors"+colors);
      this.$emit("on-colors-from-svg", Array.from(colors));
    },

    //############## SVG MANIPULATION ###############
    setSvg(content){
      document.getElementById("svgHolder").innerHTML = content;
      this.svgContent = content;
    },
    resetSvgContent(){
      this.setSvg(this.originalSvgContent);
      this.sampleColors();
    },
    //PRIVATE
    cleanUpSize(sizePair){ 
      const regex = /[a-z%]/g;
      
      var found = sizePair[0].toString().match(regex);
      if(found!=null){
        for(var i of found){
          sizePair[0] = sizePair[0].replace(i,'');
        }
      }

      found = sizePair[1].toString().match(regex);
      if(found!=null){
        for(i of found){
          sizePair[1] = sizePair[1].replace(i,'');
        }
      }
      
      if(sizePair[0] == 0 && sizePair[1] == 0){
        sizePair[0] = 400;
        sizePair[1] = 400;
      }else if(sizePair[0] == 0){
        sizePair[0] = sizePair[1];
      }else if(sizePair[1] == 0){
        sizePair[1] = sizePair[0];
      }
      return sizePair;
    },
    //PRIVATE
    computeOptimalSize(content){ 
      this.svgSize = this.cleanUpSize(getSize(content));
      console.log("svgSize:"+this.svgSize);
      var maxDim = this.svgSize[0];
      if(this.svgSize[1]>this.svgSize[0]){
        maxDim = this.svgSize[1];
      }
      var factor = 800/maxDim
      console.log("factor: "+factor);
      if(factor<1){
        this.setSize(content, factor);
      }else{
        this.setSize(content, 1);
      }
    },
    //PRIVATE
    setSize(content, factor){ //1 will keep it same. 
      //console.log("Setting with factor "+factor);
      this.svgSize = [Math.floor(this.svgSize[0]*factor), Math.floor(this.svgSize[1]*factor)];
      var resized = setSizeTo(content, this.svgSize[0], this.svgSize[1]);
      this.setSvg(resized);
    },
    zoom(change){
      //this.zoomval = this.zoomval + change
      //change is +10% or -10%
      this.setSize(this.svgContent, (change+100)/100);
    },
    onWheel(e) {
      if (this.svgAvailable) {
        // e.preventDefault() is handled by the modifier @wheel.prevent
        const delta = e.deltaY;
        if (delta < 0) {
          this.zoom(5); // Zoom in
        } else {
          this.zoom(-5); // Zoom out
        }
      }
    },

    //########## NEW UPLOAD #############
    onUpload(file){ 
      console.log("file:"+file);
      if(file.type === 'image/svg+xml'){
        console.log("loading file type svg xml");
        this.loadSvg(file, false)
      }else{
        console.log("Not expected file type:"+file.type)
        this.$message.error("Oops, Not expected file type: "+file.type);
      }
    },
    onSampleClick(sampleSvgElement){ 
      //console.log("Clicked sample: "+sampleSvgElement);
      //sampleSvgElement = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs"><rect width="10" height="10" x="200" y="200" fill="#ff0066"></rect><rect width="10" height="10" x="200" y="0" fill="#ff0066"></rect><rect width="10" height="10" x="0" y="200" fill="#ff0066"></rect><rect width="10" height="10" fill="#ff0066"></rect><rect width="10" height="10" x="100" y="100" fill="#ff0066"></rect></svg>'
      this.onSvgLoad(sampleSvgElement.toString());
      //this.$emit('on-sample-clicked-in-workspace');
      //this.loadSvg(samples[sampleIndex], true)
    },
    newUpload(){
      //Clearing all the values so that the ui is ready for new upload
      //document.getElementById("svgHolder").innerHTML = ''
      //this.svgAvailable = false;
      document.getElementById("uploadComponent").click()
      //this.$emit('ready-for-new-upload');
    },
    //PRIVATE
    loadSvg(file, isSample){ // eslint-disable-line no-unused-vars 
      if (file) {
        var reader = new FileReader();
        reader.readAsText(file, "UTF-8");
        reader.onload = evt => this.onSvgLoad(evt.target.result)
        reader.onerror = e => this.svgLoadError = "Error reading file! Please try with a different svg file!"+e;
      }
    },
    //PRIVATE
    onSvgLoad(svgcont){ 
      if(svgcont!=null){
        this.svgAvailable = true;
        var content = svgcont;
        if(content.startsWith('<?xml')){
          console.log("starts with <?xml");
          content = this.stripXmlTag(content);
          //console.log("con:"+content);
        }
        this.setSvg(content); 
        this.computeOptimalSize(this.svgContent); //calculates size and sets on svg
        this.originalSvgContent = this.svgContent; //saves so that can be used when user resets
        this.sampleColors();
        this.$emit('refresh-palette');
        this.$emit('on-svg-added-in-workspace');
        //this.setSvg(registerSelectionClick(this.svgContent));
      }
    },
    //PRIVATE
    stripXmlTag(content){ 
      var start = content.indexOf('<svg');
      var sliced = content.slice(start);
      return sliced;
    },

    //############ SAVE ##################
    save(){
      this.unselectElement();
      const svgElement = document.getElementById("svgHolder").querySelector('svg');
      
      // Ensure dimensions are up to date before saving
      /*if (svgElement) {
        svgElement.setAttribute('width', this.svgSize[0]);
        svgElement.setAttribute('height', this.svgSize[1]);
      }*/

      this.svgContent = document.getElementById("svgHolder").innerHTML;
      var svgBlob = new Blob([this.svgContent], {type:"image/svg+xml;charset=utf-8"});
      var svgUrl = URL.createObjectURL(svgBlob);
      var downloadLink = document.createElement("a");
      downloadLink.href = svgUrl;
      
      // Use SVG ID as filename if available, otherwise fallback to default
      const fileName = (svgElement && svgElement.id) ? `${svgElement.id}.svg` : "nira-recolored.svg";
      downloadLink.download = fileName;
      
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      this.$message({
          message: `Your recolored svg has been saved as ${fileName}!`,
          type: 'success'
        });
    },


    //########## SELECTION #############
    isValidSvgElement(node) {
      return node && node.tagName && ['path', 'rect', 'circle', 'ellipse', 'polygon', 'polyline', 'text'].includes(node.tagName.toLowerCase());
    },
    onElementHover(e) {
      if (this.isValidSvgElement(e.target)) {
        if (this.selectedNodes.includes(e.target)) return;
        if (!e.target.hasAttribute('data-old-stroke')) {
           e.target.setAttribute('data-old-stroke', e.target.getAttribute('stroke') || '');
           e.target.setAttribute('data-old-stroke-width', e.target.getAttribute('stroke-width') || '');
        }
        e.target.setAttribute('stroke', this.selectionHighlightColor);
        e.target.setAttribute('stroke-width', '3');
        this.hoveredNode = e.target;
      }
    },
    onElementOut(e) {
      if (this.isValidSvgElement(e.target) && !this.selectedNodes.includes(e.target)) {
        this.restoreStroke(e.target);
        if (this.hoveredNode === e.target) this.hoveredNode = null;
      }
    },
    onElementClick(e) {
      if (this.isValidSvgElement(e.target)) {
        e.stopPropagation();
        
        if (!e.ctrlKey && !e.metaKey) {
            // If not ctrl/cmd clicking, deselect others first
            this.selectedNodes.forEach(node => {
                if (node !== e.target) {
                    this.restoreStroke(node);
                }
            });
            this.selectedNodes = [];
        }

        const isAlreadySelected = this.selectedNodes.includes(e.target);
        
        if (isAlreadySelected) {
            // Deselect if already selected (toggle behavior with ctrl click)
            this.restoreStroke(e.target);
            this.selectedNodes = this.selectedNodes.filter(node => node !== e.target);
            if (this.selectedNodes.length === 0) {
                this.$emit('element-unselected');
            } else {
                 let currentFill = this.selectedNodes[this.selectedNodes.length - 1].getAttribute('fill') || '#000000';
                 if (currentFill === 'none') currentFill = '#000000';
                 this.$emit('element-selected', currentFill);
            }
        } else {
            // Select the new node
            this.selectedNodes.push(e.target);
            if (!e.target.hasAttribute('data-old-stroke')) {
               e.target.setAttribute('data-old-stroke', e.target.getAttribute('stroke') || '');
               e.target.setAttribute('data-old-stroke-width', e.target.getAttribute('stroke-width') || '');
            }
            e.target.setAttribute('stroke', this.selectionHighlightColor); // Highlight selected with chosen color
            e.target.setAttribute('stroke-width', '4');
            
            let currentFill = e.target.getAttribute('fill') || '#000000';
            if (currentFill === 'none') currentFill = '#000000';
            
            this.$emit('element-selected', currentFill);
        }
      } else {
        this.unselectElement();
        this.$emit('element-unselected');
      }
    },
    unselectElement() {
      if (this.selectedNodes.length > 0) {
        this.selectedNodes.forEach(node => {
            this.restoreStroke(node);
        });
        this.selectedNodes = [];
        this.svgContent = document.getElementById("svgHolder").innerHTML;
        this.sampleColors();
      }
    },
    applyColorHighlight(color) {
      const hex = getColor(color);
      const svgHolder = document.getElementById("svgHolder");
      const svg = SVG(svgHolder.querySelector('svg'));
      if (!svg) return;
      
      const vm = this;
      svg.each(function() {
        if (isValidColorHolderElement(this)) {
          let rawCols = getFillValue(this);
          for (let rCol of rawCols) {
            if (isColor(rCol) && getColor(rCol) === hex) {
               const node = this.node;
               if (!node.hasAttribute('data-old-stroke')) {
                 node.setAttribute('data-old-stroke', node.getAttribute('stroke') || '');
                 node.setAttribute('data-old-stroke-width', node.getAttribute('stroke-width') || '');
               }
               node.setAttribute('stroke', vm.selectionHighlightColor);
               node.setAttribute('stroke-width', '4');
            }
          }
        }
      }, true);
    },
    removeColorHighlight(color) {
      const hex = getColor(color);
      const svgHolder = document.getElementById("svgHolder");
      const svgNode = svgHolder.querySelector('svg');
      if (!svgNode) return;
      const svg = SVG(svgNode);

      const vm = this;
      svg.each(function() {
        if (isValidColorHolderElement(this)) {
          let rawCols = getFillValue(this);
          for (let rCol of rawCols) {
            if (isColor(rCol) && getColor(rCol) === hex) {
               vm.restoreStroke(this.node);
            }
          }
        }
      }, true);
    },
    restoreStroke(node) {
      if (!node) return;
      const oldStroke = node.getAttribute('data-old-stroke');
      const oldStrokeWidth = node.getAttribute('data-old-stroke-width');
      
      if (oldStroke) node.setAttribute('stroke', oldStroke);
      else node.removeAttribute('stroke');
      
      if (oldStrokeWidth) node.setAttribute('stroke-width', oldStrokeWidth);
      else node.removeAttribute('stroke-width');
      
      node.removeAttribute('data-old-stroke');
      node.removeAttribute('data-old-stroke-width');
    },


    //############ UTIL ############
    arrayEquals(a, b) {
      return Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((val, index) => val === b[index]);
    },

    

    //######## UNUSED - CAN DELETE ###########
    updateSvg(file, isSample){
      this.svgAvailable = true;

      var obj = document.createElement('object');
      obj.setAttribute("id", "svgExternalObject")

      if(isSample){
        obj.type = 'image/svg+xml'
        obj.data = file;
        console.log(file);
        obj.setAttribute("width", "80%");
        this.zoomval = 80
      }else{
        obj.data = URL.createObjectURL(file);
        obj.onload = e => URL.revokeObjectURL(obj.data); // eslint-disable-line no-unused-vars
        obj.setAttribute("width", "50%");
        this.zoomval = 50
      }
      var svgHolder = document.getElementById("svgHolder")
      svgHolder.appendChild(obj);
    },
    doOnSvgLoad(){
      window.addEventListener("load", function() {
        this.updateColorInfo();
      });
    },
    verify(){
      this.updateColorInfo();
    },
    updateColorInfo(){
      var svgObject = document.getElementById('svgExternalObject').contentDocument;
      var svg = svgObject.getElementsByTagName('svg')[0];
      console.log(svg);
      var colors = this.getColorsFromSvg(svg);
      console.log(colors);
      //var colors = getColorsFromSvg(this.getObject());
      //console.log(colors);
      //this.$emit('myEvent')
    },
    getColorsFromSvg(obj){
      const colors = new Set();
      if(obj!=null){
        var svg = SVG(obj);
        this.loopAllChildren(svg, colors);
        /*svg.each(function(i, children) { 
          console.log(i+" child:"+children);
          //colors.add(this.attr('fill'));
        }, true);*/
      }else{
        console.log("obj is null!")
      }
      return colors;
    },
    getObject(){
      var svgHolder = document.getElementById("svgHolder")
      return svgHolder.getElementsByTagName('object')[0]
    },
    getSvgObject(){
      var svgHolder = document.getElementById("svgHolder")
      return svgHolder.getElementsByTagName('object')[0].contentDocument.documentElement;
    },
    loopAllChildren(svgEle, colorSet){
      var childs = svgEle.children()
      console.log(childs);
      childs.forEach(function (child) {
        console.log(child);
        colorSet.add(child.attr('fill'));
        this.loopAllChildren(child, colorSet);
      });
    }

  }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.workspace {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.leftMargin{
  margin-left: 0px;
}

.workspaceContainer {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.optionsBar.floatingOptions {
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  height: auto;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  background-color: var(--bg-color);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  margin-bottom: 0;
}

.optionsGroup {
  display: flex;
  align-items: center;
  gap: 12px;
}

.bottomOptionsTextItem{
  font-size:small;
  font-weight: bold;
}

.bottomOptionsCircleItem{
  width: 28px;
}

</style>
